import { render, staticRenderFns } from "./StoryContent.vue?vue&type=template&id=00c4c4ee&scoped=true&"
import script from "./StoryContent.vue?vue&type=script&lang=js&"
export * from "./StoryContent.vue?vue&type=script&lang=js&"
import style0 from "./StoryContent.vue?vue&type=style&index=0&id=00c4c4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c4c4ee",
  null
  
)

export default component.exports